import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[100px] w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5",
        "text-sm text-slate-900 leading-relaxed",
        "shadow-sm transition-all duration-150",
        "placeholder:text-slate-400",
        "hover:border-slate-300",
        "focus:outline-none focus:ring-2 focus:ring-[#108981]/20 focus:border-[#108981]",
        "disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500",
        "resize-none",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
